<template>
  <div class="drag-item" >
    <VIcon class="handle" color="grey" small="small">
      fa-grip-lines
    </VIcon>

    <div class="name">
      <slot/>
    </div>

    <span class="mx-3">
      <slot name="action"/>
    </span>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="sass">
.drag-item
  padding: .25rem 0
  display: flex
  gap: .75rem

.name
  flex: 1
</style>
